<app-public-step-form title="Pedido de copia de llave" [state]="state" [steps]="steps" [submit]="submit" [form]="form"
    submitLabel="Enviar pedido" [messages]="messages">

    <!-- Pantalla 1: el pedido -->
    <ng-template appFormStep="request" let-errors>
        <form [formGroup]="form" class="krf">
            @if (data?.requester) {
                <p class="krf__hello">Hola, <b>{{ data?.requester?.firstName }}</b>. Completá estos datos y le pasamos el pedido a la administración.</p>
            }

            <!-- unidad: solo si tiene varias en esta administración -->
            @if (showUnitSelector) {
                <section class="krf__section">
                    <p class="overtitle">Unidad</p>
                    <h4>¿Para qué unidad es la llave?</h4>
                    <div class="radio-square krf__options">
                        @for (u of units; track u.consorcistaId) {
                            <input [id]="'unit-' + u.consorcistaId" type="radio" name="unit" [value]="u.consorcistaId"
                                [checked]="form.value.consorcistaId === u.consorcistaId" (change)="selectUnit(u.consorcistaId)">
                            <label [for]="'unit-' + u.consorcistaId">{{ u.consorcioName }} · {{ u.label }}</label>
                        }
                    </div>
                    <app-field-error field="consorcistaId" [errors]="errors" />
                </section>
            } @else if (unit) {
                <p class="krf__unit"><i class="pi pi-building"></i> {{ unit.consorcioName }} · {{ unit.label }}</p>
            }

            @if (unit) {
                <!-- para quién -->
                <section class="krf__section">
                    <p class="overtitle">¿Para quién es la llave?</p>
                    @if (!isRealEstate) {
                        <div class="radio-square krf__options">
                            <input id="forWhom-self" type="radio" name="forWhom" value="self" [checked]="form.value.forWhom === 'self'" (change)="setForWhom('self')">
                            <label for="forWhom-self">Para mí</label>
                            <input id="forWhom-other" type="radio" name="forWhom" value="other" [checked]="form.value.forWhom === 'other'" (change)="setForWhom('other')">
                            <label for="forWhom-other">Otra persona</label>
                        </div>
                        <app-field-error field="forWhom" [errors]="errors" />
                    }

                    @if (isOther) {
                        @if (members.length) {
                            <h4>¿La persona está registrada en la unidad?</h4>
                            <div class="radio-square krf__options">
                                <input id="other-registered" type="radio" formControlName="otherType" value="registered">
                                <label for="other-registered">Registrada en la unidad</label>
                                <input id="other-unregistered" type="radio" formControlName="otherType" value="unregistered">
                                <label for="other-unregistered">No está registrada</label>
                            </div>
                            <app-field-error field="otherType" [errors]="errors" />
                        }

                        @if (isRegistered) {
                            <label for="registeredId">Persona</label>
                            <p-dropdown inputId="registeredId" formControlName="registeredId" [options]="memberOptions" optionLabel="label"
                                optionValue="value" placeholder="Elegí a la persona" styleClass="w-full"></p-dropdown>
                            <app-field-error field="registeredId" [errors]="errors" />
                        }

                        @if (isUnregistered) {
                            <label for="firstName">Nombre</label>
                            <input id="firstName" pInputText formControlName="firstName" autocomplete="off">
                            <app-field-error field="firstName" [errors]="errors" />

                            <label for="lastName">Apellido</label>
                            <input id="lastName" pInputText formControlName="lastName" autocomplete="off">
                            <app-field-error field="lastName" [errors]="errors" />

                            <label for="phoneArea">Teléfono</label>
                            <div class="krf__phone">
                                <input id="phoneArea" pInputText formControlName="phoneArea" inputmode="numeric" placeholder="Área (ej: 341)">
                                <input id="phoneNumber" pInputText formControlName="phoneNumber" inputmode="numeric" placeholder="Número (sin el 15)">
                            </div>
                            <app-field-error field="phone" [errors]="errors" />
                        }

                        @if (isRegistered || isUnregistered) {
                            <label for="relation">Vínculo con vos</label>
                            <p-dropdown inputId="relation" formControlName="relation" [options]="relationOptions" optionLabel="label"
                                optionValue="value" placeholder="Elegí el vínculo" styleClass="w-full"></p-dropdown>
                            <app-field-error field="relation" [errors]="errors" />
                            @if (form.value.relation === 'other') {
                                <input pInputText formControlName="relationOther" placeholder="¿Cuál?" class="krf__other" autocomplete="off">
                                <app-field-error field="relationOther" [errors]="errors" />
                            }
                        }
                    }

                    @if (needsRecipientDni) {
                        <label for="recipientDni">
                            @if (form.value.forWhom === 'self') { Tu DNI } @else { DNI de quien recibe la llave }
                        </label>
                        <input id="recipientDni" pInputText formControlName="recipientDni" inputmode="numeric" placeholder="Solo números" autocomplete="off">
                        <app-field-error field="recipientDni" [errors]="errors" />
                    }
                </section>

                @if (isRealEstate) {
                    <section class="krf__section">
                        <label for="pickupResponsibleDni">DNI de la persona que va a retirar la llave</label>
                        <input id="pickupResponsibleDni" pInputText formControlName="pickupResponsibleDni" inputmode="numeric" placeholder="Solo números" autocomplete="off">
                        <app-field-error field="pickupResponsibleDni" [errors]="errors" />
                    </section>
                }

                <!-- la llave -->
                <section class="krf__section">
                    <p class="overtitle">La llave</p>
                    <h4>Tipo de llave</h4>
                    <div class="radio-square krf__options">
                        @for (o of keyTypeOptions; track o.value) {
                            <input [id]="'keyType-' + o.value" type="radio" formControlName="keyType" [value]="o.value">
                            <label [for]="'keyType-' + o.value">{{ o.label }}</label>
                        }
                    </div>
                    <app-field-error field="keyType" [errors]="errors" />
                    @if (form.value.keyType === 'other') {
                        <input pInputText formControlName="keyTypeOther" placeholder="¿Qué tipo de llave?" class="krf__other" autocomplete="off">
                        <app-field-error field="keyTypeOther" [errors]="errors" />
                    }

                    <h4>Motivo</h4>
                    <div class="radio-square krf__options">
                        @for (o of reasonOptions; track o.value) {
                            <input [id]="'reason-' + o.value" type="radio" formControlName="reason" [value]="o.value">
                            <label [for]="'reason-' + o.value">{{ o.label }}</label>
                        }
                    </div>
                    <app-field-error field="reason" [errors]="errors" />

                    @if (form.value.reason === 'replacement') {
                        <div class="krf__check">
                            <input id="lostKey" type="checkbox" formControlName="lostKey">
                            <label for="lostKey"><b>Llave perdida:</b> la llave anterior se perdió y necesita darse de baja</label>
                        </div>
                    }
                </section>
            }
        </form>
    </ng-template>

    <!-- Pantalla 2: contacto de emergencia, solo si la unidad no lo tiene -->
    <ng-template appFormStep="emergency" let-errors>
        <form [formGroup]="form" class="krf">
            <div formGroupName="emergency">
                <p class="overtitle">Contacto de emergencia</p>
                <h4 class="krf__intro">Antes de terminar por favor decinos: ¿con quién querés que nos comuniquemos si alguna vez hay un problema grave con tu unidad?</h4>

                <label for="em-firstName">Nombre</label>
                <input id="em-firstName" pInputText formControlName="firstName" autocomplete="off">
                <app-field-error field="em.firstName" [errors]="errors" />

                <label for="em-lastName">Apellido</label>
                <input id="em-lastName" pInputText formControlName="lastName" autocomplete="off">
                <app-field-error field="em.lastName" [errors]="errors" />

                <label for="em-phoneArea">WhatsApp</label>
                <div class="krf__phone">
                    <input id="em-phoneArea" pInputText formControlName="phoneArea" inputmode="numeric" placeholder="Área (ej: 341)">
                    <input id="em-phoneNumber" pInputText formControlName="phoneNumber" inputmode="numeric" placeholder="Número (sin el 15)">
                </div>
                <app-field-error field="em.phone" [errors]="errors" />

                <label for="em-relation">¿Qué relación tiene con vos?</label>
                <input id="em-relation" pInputText formControlName="relation" placeholder="Ej: madre, vecino" autocomplete="off">
                <app-field-error field="em.relation" [errors]="errors" />

                <div class="krf__check">
                    <input id="em-accessKey" type="checkbox" formControlName="accessKey">
                    <label for="em-accessKey">Tiene llave de la unidad</label>
                </div>
            </div>
        </form>
    </ng-template>
</app-public-step-form>

